module.exports = __webpack_public_path__ + "assets/Midpoint.d2b4be2cd40b0cab7e414a25a24d58f9.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/Midpoint.gmt
// module id = 971
// module chunks = 0